import { TextTheme } from '@kite-js/theme-types';
import colors from '@theme/rurubu/theme-rurubu/colors';

const text: TextTheme = {
    defaults: {
        textSize: 'M',
        textWeight: 'Normal',
        successTextColor: colors.green[300],
        warningTextColor: colors.orange[300],
        dangerTextColor: colors.red[300],
        disabledTextColor: colors.lightScale[300],
    },
};

export default text;
